import React from 'react';
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import textsService from 'services/textsService';

const HowItWorksStepper = ({ orientation }) => (
  <Stepper
    activeStep={null}
    orientation={orientation || 'horizontal'}
    alternativeLabel={orientation === 'horizontal'}
  >
    <Step key="1">
      <StepLabel>
        <div className="step-title">
          {textsService.getLocalizedText(textsService.TEXT_KEYS.EXPERIENCE_FLOW_STEP_1_TITLE)}
        </div>
        <div className="step-subtitle">
          {textsService.getLocalizedText(textsService.TEXT_KEYS.EXPERIENCE_FLOW_STEP_1_SUBTITLE)}
        </div>
      </StepLabel>
    </Step>
    <Step key="2">
      <StepLabel>
        <div className="step-title">
          {textsService.getLocalizedText(textsService.TEXT_KEYS.EXPERIENCE_FLOW_STEP_2_TITLE)}
        </div>
        <div className="step-subtitle">
          {textsService.getLocalizedText(textsService.TEXT_KEYS.EXPERIENCE_FLOW_STEP_2_SUBTITLE)}
        </div>
      </StepLabel>
    </Step>
    <Step key="3">
      <StepLabel>
        <div className="step-title">
          {textsService.getLocalizedText(textsService.TEXT_KEYS.EXPERIENCE_FLOW_STEP_3_TITLE)}
        </div>
        <div className="step-subtitle">
          {textsService.getLocalizedText(textsService.TEXT_KEYS.EXPERIENCE_FLOW_STEP_3_SUBTITLE)}
        </div>
      </StepLabel>
    </Step>
  </Stepper>
);

HowItWorksStepper.propTypes = {
  orientation: PropTypes.string,
};

HowItWorksStepper.defaultProps = {
  orientation: 'horizontal',
};

export default HowItWorksStepper;
